import React, { useState } from "react"
import Map, { Marker } from "react-map-gl"
import * as map from "./map.module.css"
import "mapbox-gl/dist/mapbox-gl.css"
import { Search } from "react-feather"
import { graphql, useStaticQuery } from "gatsby"

const ChaptersMapEditable = ({MapAcess}) => {
  const [popup, setPopup] = useState(null)
  const [search, setSearch] = useState(false)
  const [searchQuery, setSearchQuery] = useState()
  const [searchResults, setSearchResults] = useState()

  const { allContentfulChapter } = useStaticQuery(graphql`{
    allContentfulChapter(filter: {basedOn: {eq: "Location"}}) {
      nodes {
        address
        basedOn
        city
        state
        country
        location {
          lat
          lon
        }
        type
        status
        title
        website
        email
        chapterSince(formatString: "DD MMM YYYY")
      }
    }
  }`);

  const handleSearch = e => {
    let s = e.target.value
    setSearchQuery(s)
    setSearchResults(
      allContentfulChapter.nodes.filter(
        data =>
          data.city.toLowerCase().includes(s.toLowerCase()) ||
          data.country.toLowerCase().includes(s.toLowerCase())
      )
    )
  }

  const handleResult = r => {
    setPopup(r)
    setSearchResults()
    setSearchQuery()
    setSearch(!search)
  }

  return (
    <>
      <div className={map.wrapper}>
        <div className={map.searchWrapper}>
          <div className={map.locationTag}>
            <h6>Chapters by location</h6>
            <div className={search ? map.inputShow : map.inputHide}>
              <input
                type={"text"}
                placeholder={`City or country`}
                onChange={e => handleSearch(e)}
                value={searchQuery}
              />
            </div>
            <Search
              className={map.search}
              onClick={() => {
                setSearchResults()
                setSearchQuery()
                setSearch(!search)
              }}
            />
          </div>
          {searchResults?.length > 0 && (
            <div className={map.searchResults}>
              {searchResults.map(r => (
                <div className={map.result} onClick={() => handleResult(r)}>
                  {r.city}, {r.country}
                </div>
              ))}
            </div>
          )}
        </div>
        <Map
          initialViewState={{
            longitude: -36,
            latitude: 33,
            zoom: 2,
          }}
          style={{ width: "100vw", height: "80vh" }}
          mapStyle="mapbox://styles/abhinavthukral/clitsdhha01wf01p12m3pgg64"
          mapboxAccessToken={MapAcess}
          scrollZoom={false}
        >
          {allContentfulChapter.nodes.map((chapter, index) => (
            <>
              <Marker
                anchor="bottom"
                longitude={chapter.location.lon}
                latitude={chapter.location.lat}
                key={chapter.title}
              >
                <div
                  className={popup === chapter ? map.markerHighlight : map.marker}
                  onClick={() => {
                    setPopup(chapter)
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 6.243 6.377 6.903 8 16.398 1.623-9.495 8-10.155 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.342-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                  </svg>
                </div>
              </Marker>
            </>
          ))}
          {popup && (
            <div className={map.infoBox}>
              <p className={map.selected}>Selected Chapter</p>
              <hr />
              <h6>{popup.title}</h6>
              <p>
                {popup.city}, {popup.country}
              </p>
              <p>{popup.email}</p>
            </div>
          )}
        </Map>
      </div>
    </>
  )
}

export default ChaptersMapEditable
